import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/node_modules/react-bootstrap/esm/Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/node_modules/react-bootstrap/esm/Modal.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/node_modules/react-loading-skeleton/dist/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/home/BookAppointment.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/components/home/GoogleReviewBanner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/home/GoogleReviews.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/home/HomeBanner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/home/HomeH1.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/home/InfoBoxSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/home/StayConnected.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/home/StripContent.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/home/Template02.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/home/Template03.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/home/Template04.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/home/Template05.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/home/TrendingProducts.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/style/home.scss");
